import TrainingProgramList from './TrainingProgramList';

export default TrainingProgramList; 